import * as actions from '../../actions/actions'

const initialState = {
  corporateDetail: {
    corporateSenderId: '',
    corporateSenderName: '',
    enabled: false,
    campaigns: [],
    contiCorrenti: [],
    bank:'',
    logo: '',
    autoAccept:'',
    timeToExpiry:'',
    daysToFirstReminder:'',
    daysToSecondReminder:'',
    whatsapp:'',
    hasBankAuthorizer:false
  },
  error: ''
}

export default function corporateDetail(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_CORPORATE_DETAIL_SUCCESS:
      return fetchCorporateDetailSuccess(state, action)
    case actions.FETCH_CORPORATE_DETAIL_FAILURE:
      return fetchCorporateDetailFailure(state, action)
    case actions.DETAIL_CORPORATE_CLEAN:
      return detailCorporateClean(state, action)
    default:
      return state
  }
}

const fetchCorporateDetailSuccess = (state, action) => {
  return {
    ...state,
    corporateDetail: action.value
  }
}

const fetchCorporateDetailFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const detailCorporateClean = (state, action) => {
  return initialState;
}